import React from 'react';
import { useState } from 'react';
import { Alert, Divider } from '@mui/material';
import dayjs from 'dayjs';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import Functions from '../../../Helpers/Functions';
import { capitalizeFirstLetter, displayError, displayHeadInfoDeclaration, displayUploadProof, displayUploadProofs, validateDeposit, validatePrice } from '../../../Utils/Function'
import { Subject } from '../../../Objects/models/Subject';
import validateSelects from '../../../Validation/MultiStep';
import PriceFields from '../../../Components/Fields/PriceFields';
import FormSubjectSelect from '../../../Components/FormFields/FormSubjectSelect';
import FormDate from '../../../Components/FormFields/FormDate';
import DialogLayout from '../../../Components/DialogLayout';
import { useDeclarationContexte } from '../../../Contexts/DeclarationContexte';
import { SET_COURSE_DECLARATION_INFO } from '../../../Redux/Reducers/DeclarationCourseReducers';
import ImageRepository from '../../../Repositories/ImageRepository';
import FormCheckbox from '../../../Components/FormFields/FormCheckbox';
import { BrandContent, useTailwindBrand } from '../../../Components/shared';
import { ENV_TEACHR, ENV_VERIFIED_TRAINER, getActiveAppBrandConfig, getActiveClientBrandConfig, getActivePrestationBrandConfig, isBrandActive } from '../../../config/environment.config';
import AlertInfo from '../../../Components/AlertInfo';
import IndexStep from '../IndexStep';
import { VT_MONTHLY_CEILING_TTC, isCooperativeCoach, isVerifiedTrainer, vtClientShare, vtCoachShareHt, vtCoachVat, vtCommissions, vtHtFromTtc, vtIsSubjectToVat, vtTerritorialVatRate, vtTtcFromHourlyPaid, vtTtcFromNet } from '../../../Utils/VerifiedTrainerAmounts';
import { coachHtFromTtc, coachIsSubjectToVat, coachShareTtc, coachVatIncluded } from '../../../Utils/CoachVatAmounts';
import { fullNameChild } from '../../../Utils/Function';

type formType = {
  price: string | number | any;
  subject: Subject[];
  deposit?: number | any;
  date?: string | Date;
  proofDeposit?: string | any;
  proofDeposits?: any[];
  terms?: boolean;
}

const MAX_PROOFS = 8;

const ThirdStep = () => {
  const { handleChangeStep, teachr, generalStep } = useDeclarationContexte();
  const dispatch = useDispatch();
  const { classes, common, brandConfig } = useTailwindBrand()
  // const today = moment().startOf('month').toDate();
  const startAt = new Date(generalStep?.firstStep?.dateTimeTdpMoment || Date.now());
  const thirdStep = generalStep?.thirdStep
  const courseType = generalStep?.cours
  const duration = courseType ? generalStep?.secondStep?.durationMore : generalStep?.secondStep?.duration
  const defaultFees = parseFloat(teachr?.defaultFees ?? '0') || 0
  const firstStep = generalStep?.firstStep?.child
  const tva = parseFloat(teachr?.tauxTva ?? '0')
  const tauxTvaNum = Number(teachr?.tauxTva)
  const isTeachrContact = firstStep?.isTeachrContact
  const conditionScoop = isBrandActive(ENV_VERIFIED_TRAINER) || (teachr?.scoop) ? true : false
  // const defaultFees = parseFloat(teachr?.defaultFees ?? '0') || 0
  const netMultiplier = 1 - defaultFees;
  // Verified Trainer : montants déclarés et plafond en prix total TTC (cahier des charges facture 70 % vs 100 %)
  const isVt = isVerifiedTrainer();
  const maxNet = (isVt ? VT_MONTHLY_CEILING_TTC : 1980 * netMultiplier).toFixed(2);
  const [form, setForm] = useState<formType>({
    price: thirdStep ? thirdStep?.price : (isTeachrContact ? '' : firstStep?.pricePerHour),
    subject: thirdStep ? thirdStep?.subject : '',
    deposit: thirdStep?.deposit ? thirdStep?.deposit : '',
    date: thirdStep?.depositDate ? new Date(thirdStep.depositDate) : new Date(),
    proofDeposit: thirdStep?.proofDeposit ? thirdStep?.proofDeposit : '',
    proofDeposits: thirdStep?.proofDeposits ? thirdStep?.proofDeposits : [],
    terms: thirdStep?.terms ? thirdStep?.terms : false,
  })
  const [error, setError] = useState({
    price: false,
    matiere: false,
    deposit: false,
    proof: false,
    terms: false,
    checked: false,
    date: false,
    errorMsg: '',
    errorMsgDate: ""
  });
  const [open, setOpen] = useState({
    infoPrice: false,
    infoDeposit: false,
    validDeposit: false,
    loading: false,
  })
  const [checked, setChecked] = React.useState(thirdStep?.checked ?? false);
  const price = {
    teachrPrice: Functions.priceTotal(form.price, defaultFees).toFixed(2),
    montantFacture: parseFloat(tauxTvaNum === 10 ? form.price * 0.9 : tauxTvaNum === 20 ? form.price * 0.8 : form.price) * 2 * duration
  }
  const alreadyDeclaredAmount = isVt ? vtTtcFromNet(firstStep?.amount, teachr) : parseFloat(firstStep?.amount ?? '0') * netMultiplier;
  const selectedDeclaredMonth = generalStep?.secondStep?.date ? moment(generalStep.secondStep.date).format('YYYY-MM') : null;
  const isCurrentMonthDeclaration = selectedDeclaredMonth === moment().format('YYYY-MM');
  const newDeclarationAmount = isVt
    ? vtTtcFromHourlyPaid(form.price, duration)
    : (isNaN(price.montantFacture) ? 0 : (price.montantFacture) * netMultiplier);
  const totalDeclaredIfAdded = alreadyDeclaredAmount + newDeclarationAmount;
  // Le plafond est atteignable : seul un dépassement bloque, comparé au centime pour éviter les faux positifs
  // des arrondis flottants (1 820 + 160 doit passer avec un plafond de 1 980), toutes marques confondues.
  const wouldExceedMonthlyLimit = isCurrentMonthDeclaration && !!form.price && newDeclarationAmount > 0
    && Math.round(totalDeclaredIfAdded * 100) / 100 > parseFloat(maxNet);

  const getSubject = (value: Subject[]) => {
    setForm((prev) => ({ ...prev, subject: value }));
  };
  const getPrice = (value: string) => {
    setForm((prev) => ({ ...prev, price: value }));
  }
  const getDesposit = (value: number | any) => {
    setForm((prev) => ({ ...prev, deposit: value }));
    if (value) {
      setError((prev) => ({ ...prev, checked: false }));
    }
  }
  const getDate = (value: string) => {
    if (value !== "") {
      let dateCourse = value && dayjs.isDayjs(value) ? moment(value.format('YYYY/MM/DD')) : moment(value)
      if (moment(dateCourse).format("YYYY-MM-DD") < moment(startAt).format("YYYY-MM-DD")) {
        setError((prev) => ({
          ...prev,
          date: moment(dateCourse).format("YYYY-MM-DD") < moment(startAt).format("YYYY-MM-DD"),
          errorMsgDate: `La date d'acompte ne peut pas être antérieure à la date de validation de compte de votre ${getActiveClientBrandConfig()}.`
        }));
      }
      setForm((prev) => ({ ...prev, date: value }));
    }
  }
  const getFile = (value: File, error: boolean) => {
    if (error) {
      setError((prev) => ({ ...prev, errorMsg: "Mauvais format de fichier" }));
    } else {
      setOpen((prev) => ({ ...prev, loading: true }));
      setError((prev) => ({ ...prev, errorMsg: "" }));
      const fileType = value.type.split("/");
      if (value.type.search("image") === 0) {
        Functions.resizeFile(value, true, fileType[1]).then((response: any) => {
          if (URL.createObjectURL(response)) {
            createImage(response);
          }
        });
      } else {
        createImage(value);
      }
    }
  };
  const deletImage = () => {
    setOpen((prev) => ({ ...prev, loading: true }));
    ImageRepository.deletImage(form?.proofDeposit?.id).then(() => {
      setForm((prev) => ({ ...prev, proofDeposit: "" }));
      handleDispatch(3, true)
    }).catch((error: any) => {
      setOpen((prev) => ({ ...prev, loading: false }));
      console.error("Error deleting image:", error);
    }).finally(() => {
      setOpen((prev) => ({ ...prev, loading: false }));
      handleDispatch(3, true)
    })
  }
  const deletImageMulti = (index: number) => {
    const target = form.proofDeposits?.[index];
    if (!target) return;
    setOpen((prev) => ({ ...prev, loading: true }));
    ImageRepository.deletImage(target?.id).then(() => {
      const newProofs = (form.proofDeposits || []).filter((_, i) => i !== index);
      setForm((prev) => ({ ...prev, proofDeposits: newProofs }));
      handleDispatch(3, false, newProofs)
    }).catch((error: any) => {
      setOpen((prev) => ({ ...prev, loading: false }));
      console.error("Error deleting image:", error);
    }).finally(() => {
      setOpen((prev) => ({ ...prev, loading: false }));
    })
  }
  const createImage = (file: File) => {
    ImageRepository.createImage(new File([file], "proof-deposit", { type: "application/pdf" })).then((response) => {
      if (courseType) {
        const newProofs = [...(form.proofDeposits || []), response];
        setForm((prev) => ({ ...prev, proofDeposits: newProofs }));
        setError((prev) => ({ ...prev, proof: false }));
        handleDispatch(3, false, newProofs)
      } else {
        setForm((prev) => ({ ...prev, proofDeposit: response }));
        handleDispatch(3, false)
      }
    }).catch((error: any) => {
      setOpen((prev) => ({ ...prev, loading: false }));
      console.error(
        "Error updating teachr:",
        JSON.parse(JSON.stringify(error))._description
      );
      // Invalid filename provided
      if (JSON.parse(JSON.stringify(error))._description === "Invalid filename provided") {
        setError((prev) => ({ ...prev, errorMsg: "" }));
        console.error(
          JSON.parse(JSON.stringify(error))._description || "An error occurred while uploading the file."
        );
      } else {
        console.error(JSON.parse(JSON.stringify(error)));
      }
    }).finally(() => {
      setOpen((prev) => ({ ...prev, loading: false }));
      handleDispatch(3, false)
    })
  }
  const handleOpen = () => {
    setOpen((prev) => ({ ...prev, infoPrice: true }))
  };
  const handleClose = () => {
    setOpen((prev) => ({ ...prev, infoPrice: false }))
  };
  const handleOpen2 = () => {
    setOpen((prev) => ({ ...prev, infoDeposit: true }))
  };
  const handleClose2 = () => {
    setOpen((prev) => ({ ...prev, infoDeposit: false }))
  };
  const handleClose3 = () => {
    setOpen((prev) => ({ ...prev, validDeposit: false }))
  };
  const validate = () => {
    let isValid = true;
    let errors = {
      price: false,
      matiere: false,
      deposit: false,
      proof: false,
      terms: false,
      checked: false,
      date: false,
      errorMsg: '',
      errorMsgDate: ''
    };
    let dateCourse = form.date && dayjs.isDayjs(form.date) ? moment(form.date.format('YYYY/MM/DD')) : moment(form.date)
    if (isTeachrContact) {
      if (!validatePrice(form.price, duration).isValid) {
        errors.price = true;
        isValid = false;
      }
    }

    if (!validateSelects(Array.isArray(form.subject) ? form.subject[0] : undefined).isValid && !isBrandActive(ENV_VERIFIED_TRAINER)) {
      errors.matiere = true;
      isValid = false;
    }
    if (checked) {
      // if (checked && !form.deposit) {
      //   errors.checked = true;
      //   isValid = false
      // }
      if (!validateDeposit(form.deposit, price.montantFacture / 2, checked).isValid) {
        errors.deposit = true;
        isValid = false
      }
      // Preuve de paiement obligatoire (demande du 23 octobre 2026) : au moins
      // un justificatif, en plus de l'attestation sur l'honneur.
      const hasProof = courseType
        ? (form.proofDeposits || []).length > 0
        : Object.values(form.proofDeposit || {}).length > 0;
      if (!hasProof) {
        errors.proof = true;
        isValid = false;
      }
      if (!form.terms) {
        errors.terms = true;
        isValid = false;
      }
      if (moment(dateCourse).format("YYYY-MM-DD") < moment(startAt).format("YYYY-MM-DD")) {
        errors.date = true
        errors.errorMsgDate = `La date d'acompte ne peut pas être antérieure à la date de validation de compte de votre ${getActiveClientBrandConfig()}.`
        isValid = false;
      }
    }

    // Plafond mensuel : montant déjà déclaré + cette déclaration > 2 200 €
    if (wouldExceedMonthlyLimit) {
      errors.price = true;
      isValid = false;
    }

    setError(errors);

    return isValid;
  };
  const handleDispatch = (value: number, isDelete?: boolean, proofsOverride?: any[]) => {
    const proofsToStore = proofsOverride !== undefined ? proofsOverride : (form.proofDeposits || []);
    dispatch({
      type: SET_COURSE_DECLARATION_INFO,
      payload: {
        step: value,
        firstStep: generalStep?.firstStep,
        secondStep: generalStep?.secondStep,
        thirdStep: {
          subject: isBrandActive(ENV_VERIFIED_TRAINER) ? 108 : form.subject,
          price: isTeachrContact ? form.price : firstStep?.pricePerHour,
          teachrPrice: isTeachrContact ? price.teachrPrice : firstStep?.pricePerHour,
          deposit: checked ? form.deposit : null,
          depositDate: checked ? (form.date ? new Date(form.date).toISOString() : null) : null,
          depositStay: checked ? (price.montantFacture / 2 - form.deposit) : null,
          proofDeposit: checked && !courseType ? (isDelete ? "" : (form.proofDeposit ? JSON.parse(JSON.stringify(form.proofDeposit)) : '')) : null,
          proofDeposits: checked && courseType ? JSON.parse(JSON.stringify(proofsToStore)) : null,
          terms: checked ? form.terms : null,
          // attestation sur l'honneur d'acompte, signée côté serveur à la validation
          depositAttestationAccepted: checked ? form.terms === true : null,
          checked: checked
        },
        cours: generalStep?.cours
      }
    });
  }

  const handleNexStep = (value: number) => {
    if (validate()) {
      if (generalStep && thirdStep) {
        handleDispatch(value, false)
        handleChangeStep(value)
      } else {
        handleDispatch(value, false)
        handleChangeStep(value)
      }
    }
  }
  const handleNextButton = (value: number) => {
    if (validate()) {
      if (checked) {
        // if ((form.deposit && form.deposit < price.montantFacture / 2 && !form.terms) && checked) {
        return setOpen((prev) => ({ ...prev, validDeposit: true }))
      } else {
        return handleNexStep(value)
      }
    }
  }
  const handleSubmit = () => handleNexStep(4)
  const handleError = (value: any) => setError((prev) => ({ ...prev, errorMsg: value }))
  // Teach'r et Déclarons : part du prof comme sur sa facture (prix horaire du prof × heures), TVA comprise s'il est
  // assujetti et jamais ajoutée par-dessus ; la TVA vaut taux % de cette part (105 € à 20 % : 84 € HT et 21 € de TVA)
  const coachTtc = coachShareTtc(form.price, duration, teachr)
  const coachTva = coachVatIncluded(coachTtc, teachr)
  const coachAssujetti = coachIsSubjectToVat(teachr)
  const coachHourlyTtc = coachShareTtc(form.price, 1, teachr)
  // Coopérative Verified Trainer SAP (marque Verified Trainer, et profs Teach'r passés par la coopérative) : tous les
  // montants sont exprimés sur le total du cours (prix horaire × 2 × durée). Part du coach comme sur sa facture
  // adressée à Verified Trainer : part HT du cours au taux de TVA du territoire du client (code postal de son
  // adresse par défaut, métropole à défaut), TVA ajoutée par-dessus s'il est assujetti.
  const coopSplit = isCooperativeCoach(teachr)
  const territorialRate = vtTerritorialVatRate(firstStep?.zip)
  const vtTtcCourse = vtTtcFromHourlyPaid(form.price, duration)
  const vtCoachHt = vtCoachShareHt(vtTtcCourse, teachr, territorialRate)
  const vtCoachTva = vtCoachVat(vtTtcCourse, teachr, territorialRate)
  const vtCoachTtc = vtCoachHt + vtCoachTva
  const vtAssujetti = vtIsSubjectToVat(teachr)

  return (
    <>
      <DialogLayout
        title="Comment cela est-il possible ?"
        handleCloseIcon={handleClose}
        text={
          <p className={`${common.body} ${classes.text}  ${classes.fontFamily} `}>
            {

              coopSplit ? <>
                En facturant votre {getActivePrestationBrandConfig()} à <strong className={classes.primaryText}>{vtTtcCourse.toFixed(2)}€</strong>, votre {getActiveClientBrandConfig()} ne paie que la moitié : <strong className={classes.primaryText}>{vtClientShare(vtTtcCourse).toFixed(2)}€</strong>. Verified Trainer SAP facture ce montant, soit <strong className={classes.primaryText}>{vtHtFromTtc(vtTtcCourse, territorialRate).toFixed(2)}€</strong> hors TVA (TVA à {territorialRate} %). Vous gagnerez <strong className={classes.primaryText}>{vtCoachHt.toFixed(2)}€</strong> hors TVA après commissions ({vtCommissions(vtTtcCourse, teachr, territorialRate).toFixed(2)}€){vtAssujetti ? <>, soit <strong className={classes.primaryText}>{vtCoachTtc.toFixed(2)}€</strong> reçus avec votre TVA ({vtCoachTva.toFixed(2)}€) ajoutée par-dessus</> : ""}.
              </> : <>
                En facturant votre {getActivePrestationBrandConfig()} à <strong className={classes.primaryText}>{price && (form.price * 2).toFixed(2)}€</strong>, votre {getActiveClientBrandConfig()} ne paiera que la moitié. Les frais de gestion de {getActiveAppBrandConfig()} étant de <strong className={classes.primaryText}></strong> {defaultFees * 100}% du montant facturé, Soit <strong className={classes.primaryText}>{price && (form.price * 2 * defaultFees).toFixed(2)}€</strong>, vous gagnerez donc <strong className={classes.primaryText}>{form.price && (form.price * 2).toFixed(2)}€ - {form.price && (form.price * 2 * defaultFees).toFixed(2)}€ = {price && (form.price * 2 * (1 - defaultFees)).toFixed(2)}€</strong> par heure de {getActivePrestationBrandConfig()} facturée à ce prix-là.{coachAssujetti ? <> Ce montant comprend votre TVA ({tva} %) : <strong className={classes.primaryText}>{coachVatIncluded(coachHourlyTtc, teachr).toFixed(2)}€</strong> par heure, soit <strong className={classes.primaryText}>{coachHtFromTtc(coachHourlyTtc, teachr).toFixed(2)}€</strong> hors TVA.</> : ""}
              </>
            }
          </p>

        }
        open={open.infoPrice}
        customDialogActions="hidden"
      />
      <DialogLayout
        title='Voulez-vous valider cet acompte ?'
        text={<p className={`${common.body} ${classes.text}  ${classes.fontFamily} `}>
          Vous avez indiqué que votre {getActiveClientBrandConfig()} vous règle un acompte total pour {getActivePrestationBrandConfig("", "ce ", "cette ")} dont le montant est de <strong className={classes.primaryText}>{form.deposit}€</strong>.
          Cependant, le reste à charge total de votre {getActiveClientBrandConfig()} pour {getActivePrestationBrandConfig("", "ce ", "cette ")} étant de <strong className={classes.primaryText}>{price.montantFacture / 2}€</strong>, il lui restera donc <strong className={classes.primaryText}>{price.montantFacture / 2 - form.deposit}€</strong> à charge{price.montantFacture / 2 - form.deposit > 0 ? ", qui lui seront prélevés sur son compte bancaire" : ""}. Voulez-vous valider le montant de l’acompte ?
        </p>}
        open={open.validDeposit}
        cancel='Retour'
        valid='Valider'
        handleSubmit={handleSubmit}
        handleClose={handleClose3}
      />
      <DialogLayout
        title={`Recevez un acompte de vos ${getActiveClientBrandConfig("s")}`}
        text={<p className={`${common.body} ${classes.text} ${classes.fontFamily} `}>
          Vous avez désormais la possibilité de demander à vos {getActiveClientBrandConfig("s")} de vous régler directement une partie ou la totalité de son reste à charge pour {getActivePrestationBrandConfig("", "le ", "la ")}. Par exemple, si votre {getActivePrestationBrandConfig()} est facturé au total <strong className={classes.primaryText}>100€</strong>, {getActiveClientBrandConfig("", "de l'", "du ")} peut vous régler un acompte pouvant aller de <strong className={classes.primaryText}>1€</strong> à <strong className={classes.primaryText}>50€</strong> maximum. Pour {getActivePrestationBrandConfig("", "ce ", "cette ")} facturé  <strong className={classes.primaryText}>100€</strong>, le montant dû à votre {getActiveClientBrandConfig()} après crédit d’impôt instantané étant de <strong className={classes.primaryText}>50€</strong>, s’il vous a réglé un acompte de <strong className={classes.primaryText}>50€</strong>, aucun reste à charge ne lui sera facturé. Les <strong className={classes.primaryText}>50€</strong> de crédit d’impôt seront débloqués et versés en début de mois suivant, déduits des frais de gestion <strong className={classes.primaryText}>{getActiveAppBrandConfig()}</strong>.
        </p>}
        open={open.infoDeposit}
        customDialogActions='hidden'
        handleClose={handleClose2}
      />
      <IndexStep
        title={courseType ? `📚 Plusieurs ${getActivePrestationBrandConfig("s")}` : `📅 ${capitalizeFirstLetter(getActivePrestationBrandConfig(' ponctuelle', "", "", " ponctuel"))}`}
        body={<>
          {/* Bannière plafond mensuel */}
          {isCurrentMonthDeclaration && (
            <Alert
              severity={wouldExceedMonthlyLimit ? 'error' : totalDeclaredIfAdded > 1800 ? 'warning' : 'info'}
              variant="outlined"
              sx={{ mb: 2, fontSize: '0.82rem', fontFamily: brandConfig.fontFamily }}
            >
              Montant déclaré ce mois pour{firstStep?.childFirstName ? ` ${capitalizeFirstLetter(firstStep.childFirstName)}` : ` ce ${getActiveClientBrandConfig()}`} :{' '}
              <strong>{alreadyDeclaredAmount.toFixed(2)}€</strong>
              {form.price && newDeclarationAmount > 0 && (
                <> + <strong>{newDeclarationAmount.toFixed(2)}€</strong> (cette déclaration) = <strong>{totalDeclaredIfAdded.toFixed(0)}€</strong></>
              )}
              {' '}/ {maxNet} €
              {wouldExceedMonthlyLimit && (
                <><br /><strong>Plafond mensuel dépassé !</strong> Revenez à l'étape précédente et sélectionnez une date dans un autre mois.</>
              )}
            </Alert>
          )}
          <BrandContent
            tag="p"
            children={displayHeadInfoDeclaration(firstStep, classes, courseType, duration)}
            type="description"
            className={`mb-4`}
          />
          <BrandContent
            tag="div"
            children={<>
              <>
                <BrandContent
                  tag="div"
                  children={<>
                    <FormSubjectSelect
                      callBack={getSubject}
                      defaultValue={Array.isArray(form.subject) ? form.subject : []}
                      placeholder={`Ex : ${isBrandActive(ENV_TEACHR) ? "Mathématiques" : "Jardinage"}`}
                      label={capitalizeFirstLetter(getActivePrestationBrandConfig('s'))}
                      error={error.matiere ? validateSelects(form.subject[0]).message : undefined}
                      multiple={false}
                    />
                  </>}
                  type="description"
                  className={`w-full space-y-2 ${isBrandActive(ENV_VERIFIED_TRAINER) ? 'hidden' : ''}`}
                />
                <BrandContent
                  tag="div"
                  children={<>
                    <PriceFields
                      getTeachrPrice={getPrice}
                      value={form.price}
                      customPrice={""}
                      name='price'
                      label="Prix horaire payé"
                      error={error.price}
                      errorMsg={wouldExceedMonthlyLimit
                        ? `Total ce mois (${totalDeclaredIfAdded.toFixed(0)}€) dépasserait le plafond de ${maxNet} €. Changez la date à l'étape précédente.`
                        : validatePrice(form.price, duration).message}
                    />
                    {/* {displayError(error.price, validatePrice(form.price, duration).message, classes)} */}
                  </>}
                  type="description"
                  className={` ${!isTeachrContact ? 'hidden' : ''} ${isBrandActive(ENV_VERIFIED_TRAINER) ? 'col-span-2' : ''} w-full space-y-2`}
                />
                <BrandContent
                  tag="div"
                  children={<>
                    <FormCheckbox
                      label={`Le client m’a avancé une partie des frais de ${getActivePrestationBrandConfig("", "ce ", "cette ")}`}
                      checked={checked}
                      onChange={() => setChecked(!checked)}
                      required={false}
                      classLabel={common.body}
                    />
                  </>}
                  type="description"
                  className={`w-full space-y-2 font-bold lg:col-span-2 ${!isTeachrContact || conditionScoop ? "hidden" : ""}`}
                />

                {
                  checked && !conditionScoop ?
                    <>
                      <BrandContent
                        tag="div"
                        children={<>
                          <PriceFields
                            getTeachrPrice={getDesposit}
                            value={form.deposit}
                            name='deposit'
                            customPrice={""}
                            label="Acompte"
                            error={error.deposit}
                            errorMsg={validateDeposit(form.deposit, price.montantFacture / 2, checked).message}
                          />
                        </>}
                        type="description"
                        className={`w-full space-y-2 ${form.deposit ? '' : 'col-span-1'}`}
                      />
                      <div className={form.deposit ? '' : 'hidden'}>
                        <FormDate
                          defaultValue={form.date as string | Date}
                          callback={getDate}
                          label="Date d'acompte"
                          error={error.date ? error.errorMsgDate : undefined}
                        />
                      </div>
                      <BrandContent
                        tag="p"
                        children={<>
                          {(form.deposit && form.price) && (price.montantFacture / 2 - form.deposit < 0 ?
                            `Vous ne pouvez sélectionner un montant d’acompte supérieur au reste à charge de votre ${getActiveClientBrandConfig()}` :
                            <span>Soit un reste à charge pour votre {getActiveClientBrandConfig()} de <strong className={classes.primaryText}>{(price.montantFacture / 2 - form.deposit).toFixed(2)}€</strong></span>)
                          }
                        </>}
                        type="description"
                        className={`${price.montantFacture / 2 - form.deposit < 0 ? `${classes.error} italic font-bold` : 'text-normal italic'} col-span-2`}
                      />

                      <BrandContent
                        tag="div"
                        children={<>
                          <p className={`${classes.fontFamily} lg:text-base text-sm px-4 font-bold`}>Attestation sur l'honneur d'acompte</p>
                          <p className={`${classes.fontFamily} lg:text-base text-sm px-4 font-normal`}>
                            Je soussigné(e) <strong className={classes.primaryText}>{teachr?.firstName} {teachr?.lastName}</strong>, atteste sur l'honneur avoir reçu de {getActiveClientBrandConfig("", "mon ", "mon ")} <strong className={classes.primaryText}>{fullNameChild(firstStep?.childFirstName, firstStep?.childLastName)}</strong> la somme de <strong className={classes.primaryText}>{form.deposit ? `${parseFloat(form.deposit).toFixed(2)} €` : "…"}</strong> le <strong className={classes.primaryText}>{form.date ? moment(form.date).format("DD/MM/YYYY") : "…"}</strong>, à titre d'acompte pour {getActivePrestationBrandConfig("", "ce ", "cette ")}. J'ai connaissance que cette attestation pourra être présentée aux organismes de contrôle compétents et que toute fausse déclaration m'expose à des sanctions.
                          </p>
                          <FormCheckbox
                            label="Je certifie sur l'honneur l'exactitude de cette attestation et je la signe électroniquement en validant ma déclaration"
                            checked={form.terms ?? false}
                            onChange={() => setForm((prev) => ({ ...prev, terms: !prev.terms }))}
                            error={error.terms ? "Vous devez certifier cette attestation pour continuer" : undefined}
                          />
                          <p className={`${classes.fontFamily} text-xs px-4 font-normal italic`}>
                            Le document signé sera archivé dans Mes documents et envoyé par e-mail. La preuve de versement ci-dessous est obligatoire.
                          </p>
                        </>}
                        type="description"
                        className={`w-full space-y-2 font-bold ${form.deposit ? "" : "hidden"} col-span-2`}
                      />
                      {(form.deposit && form.deposit !== "0" && form.price) && (price.montantFacture / 2 - form.deposit < 0 ? "" :
                        (courseType
                          ? displayUploadProofs(form.proofDeposits || [], open.loading, error.proof, handleError, getFile, deletImageMulti, classes, MAX_PROOFS)
                          : displayUploadProof(Object.values(form.proofDeposit).length, open.loading, form?.proofDeposit?.contentUrl, form?.proofDeposit?.filePath, error.proof, handleError, getFile, deletImage, classes))
                      )}
                      {displayError(error.proof, "Vous devez joindre une preuve d'acompte pour continuer.", classes)}
                    </>
                    : ""
                }
              </>
            </>}
            type="description"
            className={`lg:grid ${!isTeachrContact ? 'lg:grid-cols-1' : 'lg:grid-cols-2'} ${common.body} grid-cols-1 lg:gap-x-4 lg:gap-y-6 flex flex-col gap-y-4`}
          />
          <Divider className='my-4' />
          {(checked || form.price) && isTeachrContact ?
            <AlertInfo
              msg={
                <div className={`text-left ${classes.text}`}>
                  <li className={`${checked ? "" : "hidden"} ${classes.text} ${classes.fontFamily}`}>Votre élève peut vous régler ce cours directement <br /></li>
                  <li className={`${checked ? "" : "hidden"} ${classes.text} ${classes.fontFamily}`}>Veuillez sélectionner le montant total de l’acompte versé par votre élève, et la date associée. <button onClick={handleOpen2} className={`underline font-bold ${classes.primaryText} italic`}>en savoir plus</button>
                  </li>
                  {form.price && (coopSplit
                    ? <li className={classes.fontFamily}>Prix total de {getActivePrestationBrandConfig("", "ce ", "cette ")} : <strong className={`${classes.primaryText} ${classes.fontFamily}`}>{vtTtcCourse.toFixed(2)}€</strong> ({(form.price * 2).toFixed(2)}€ par heure sur <strong className={`${classes.primaryText} ${classes.fontFamily}`}>{Functions.renderDuration(duration * 2)}</strong>). Votre {getActiveClientBrandConfig()} paie <strong className={`${classes.primaryText} ${classes.fontFamily}`}>{vtClientShare(vtTtcCourse).toFixed(2)}€</strong>. Vous allez recevoir <strong className={`${classes.primaryText} ${classes.fontFamily}`}>{vtCoachTtc.toFixed(2)}€</strong> sur votre compte bancaire{vtAssujetti ? <>, dont <strong className={`${classes.primaryText} ${classes.fontFamily}`}>{vtCoachTva.toFixed(2)}€</strong> de TVA ajoutée à votre part de {vtCoachHt.toFixed(2)}€ hors TVA</> : <> (hors TVA)</>}. <button onClick={handleOpen} className={`underline font-bold ${classes.primaryText} italic`}>en savoir plus</button></li>
                    : <li className={classes.fontFamily}>Sur la base d'un montant de <strong className={`${classes.primaryText} ${classes.fontFamily}`}>{conditionScoop ? (form.price * 2).toFixed(2) : price.teachrPrice}€</strong> par heure dispensée. Pour une durée de <strong className={`${classes.primaryText} ${classes.fontFamily}`}>{Functions.renderDuration(duration * 2)}</strong> de cours, vous allez recevoir
                    <strong className={`${classes.primaryText} ${classes.fontFamily}`}> {coachTtc.toFixed(2)}€</strong> sur votre compte bancaire{coachAssujetti ? <>, TVA comprise, dont <strong className={`${classes.primaryText} ${classes.fontFamily}`}>{coachTva.toFixed(2)}€</strong> de TVA</> : ""}. <button onClick={handleOpen} className={`underline font-bold ${classes.primaryText} italic`}>en savoir plus</button> </li>)}
                  {(tva && price && !coopSplit) ? <li className={classes.fontFamily}>Le prix que vous mentionnez ici est le prix TTC, en y incluant vos {tva}% de TVA Vous souhaitez modifier vos taux de TVA </li> : ""}

                </div>
              }
              info="info"
              customClass=""
            /> : ''}
        </>}
        handleChangeStep={handleChangeStep}
        handleNexStep={handleNextButton}
        value={4}
        step={3}
        generalStep={generalStep}

      />
    </>
  );
};

export default ThirdStep;
